import * as FullStory from '@fullstory/browser';
import { shouldIntegrateSessionRecording } from '@modules/common/utils';
import { User } from 'v2/core/entities/user';

export const identifyFullStoryUser = (user: User) => {
  if (!shouldIntegrateSessionRecording(user.id)) {
    return;
  }

  FullStory.identify(user.email, {
    ...user,
    tenant: {
      ...user.tenant,
      dashboardSettings: {},
    },
  });
};
